module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "bottom": "0",
      "height": "100vh"
    },
    style: ([_vm.setHorizontal, {
      'width': _vm.width + 'px',
      'transform': _vm.translateWidth
    }])
  }, [(_vm.visible) ? _vm._t("default") : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05dfb780","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./Resources/Private/JavaScript/components/layout/SidebarOffCanvas.vue
// module id = 103
// module chunks = 0